class AccountNavigation {
  constructor(account) {
    this.account = account;
    this.root = window.GkifySettings.routes.root == '/' ? '' : window.GkifySettings.routes.root;
    this.init();
  }
  init() {
    history.scrollRestoration = 'manual';

    this.navItems = document.querySelectorAll('[data-nav-item]');
    this.sections = document.querySelectorAll('[data-section]');

    // 监听移动端取消按钮点击事件
    addEventDelegate({
      selector: '[data-account-cancel]',
      handler: () => {
        window.location.href = `${this.root}/account`;
      },
    });

    // 初始化时根据 URL hash 激活对应菜单
    this.handleHashChange();

    // 监听 hash 变化
    window.addEventListener('hashchange', () => this.handleHashChange());

    detectMobile(({ isMobile }) => {
      if (isMobile) {
        this.account.classList.remove('g-color-footer');
      } else {
        this.account.classList.add('g-color-footer');
      }
    });
  }

  handleHashChange() {
    const hash = window.location.hash;
    // 移除所有激活状态
    this.navItems.forEach((item) => item.classList.remove('active'));
    this.sections.forEach((section) => (section.style.display = 'none'));

    const activeNavItem = document.querySelector(`[href="${hash}"]`);
    // 激活当前项
    if (hash) {
      // 激活导航项
      if (activeNavItem) {
        activeNavItem.classList.add('active');
      }
      // 显示对应内容
      try {
        const activeSection = document.querySelector(hash);
        if (activeSection) {
          activeSection.style.display = 'block';
        }
      } catch (error) {
        console.log('error', error);
      }
    } else {
      const isMobile = window.matchMedia(GkifyTheme.config.mediaQueryMobile).matches;
      console.log('isMobile', isMobile);
      if (isMobile) return;
      window.location.href = `${this.root}/account#my-orders`;
      return;
    }
    if (!activeNavItem) {
      window.location.href = `${this.root}/account`;
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // 初始化
  const account = document.querySelector('.g-account');
  if (account) {
    new AccountNavigation(account);
  }

  const isMobile = window.matchMedia(GkifyTheme.config.mediaQueryMobile).matches;
  if (!isMobile) return;

  const wrapper = document.querySelector('.g-account__wrapper');
  const navigation = document.querySelector('.g-account__navigation');
  const contentWrapper = document.querySelector('.g-account__content');
  const backButtons = document.querySelectorAll('.g-profile__back-btn');

  function handleNavigation() {
    const hash = window.location.hash;

    if (!hash) {
      // 只显示导航菜单
      wrapper.classList.remove('g-account__wrapper--section-active');
      navigation.style.display = 'block';
      navigation.style.width = '100%';
      contentWrapper.style.display = 'none';
    } else {
      // 显示对应的内容区域
      wrapper.classList.add('g-account__wrapper--section-active');
      navigation.style.display = 'none';
      contentWrapper.style.display = 'block';
    }
  }

  // 监听 hash 变化
  window.addEventListener('hashchange', handleNavigation);

  // 初始化页面状态
  handleNavigation();

  // 返回按钮点击事件
  backButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      let root = window.GkifySettings.routes.root == '/' ? '' : window.GkifySettings.routes.root;
      window.location.href = `${root}/account`;
    });
  });
});
